module.exports = __webpack_public_path__ + "img/location.eced27ba.svg";